__turbopack_context__.v({
  "body": "GchSPW_body",
  "closeButton": "GchSPW_closeButton",
  "icon": "GchSPW_icon",
  "label": "GchSPW_label",
  "message": "GchSPW_message",
  "root": "GchSPW_root",
  "title": "GchSPW_title",
  "wrapper": "GchSPW_wrapper",
});
